import React, { ForwardedRef, useEffect, useMemo } from 'react';
import CustomShaderMaterial from '../CustomShaderMaterial';
import { Color, ShaderMaterial } from 'three';
import { Dict } from '../../../utils/Dict';

type Props = {
  color?: number,
  color2?: number,
  flattenPerspective?: boolean,
  depthTest?: boolean,
  depthWrite?: boolean,
};

// disables tone mapping
const FlatColorMaterial = React.forwardRef(({ color, color2, flattenPerspective, ...props}: Props, ref?: ForwardedRef<ShaderMaterial>) =>
{
  const uniforms = useMemo(() =>
  {
    return {
      color1: { value: new Color() },
      color2: { value: new Color() } // forms an optional base colour for the arrows
    };
  }, []);

  const defines = useMemo(() => {
    const d = {} as Dict<number>;

    if (flattenPerspective)
      d.FLATTEN_PERSPECTIVE = 1;

    return d;
  }, [flattenPerspective]);

  useEffect(() =>
  {
    uniforms.color1.value.set(color || 0x000000);
  }, [ color, uniforms ]);

  useEffect(() =>
  {
    uniforms.color2.value.set(color2 || color || 0x000000);
  }, [ color, color2, uniforms ]);

  return <CustomShaderMaterial ref={ref}
    fragmentID="flatColorFragmentShader"
    vertexID="flatColorVertexShader"
    uniforms={uniforms}
    defines={defines}
    transparent={true}
    {...props}
  />;
});

FlatColorMaterial.displayName = 'FlatColorMaterial';

export default FlatColorMaterial;